var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _vm._l(_vm.items, function(item, index) {
        return _c(
          "DIV",
          { key: index, staticClass: "d-flex flex-col form-row" },
          [
            _vm.items.length > 1
              ? _c("div", { staticClass: "col-auto" }, [
                  _vm._v("\n      #" + _vm._s(index + 1) + "\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col" },
              [
                _c(
                  "DIV",
                  { staticClass: "mb-2" },
                  [
                    _c("ItpFormInput", {
                      attrs: {
                        name: "name",
                        required: "",
                        readonly: _vm.readonly
                      },
                      model: {
                        value: item.name,
                        callback: function($$v) {
                          _vm.$set(item, "name", $$v)
                        },
                        expression: "item.name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("DIV", { staticClass: "form-row align-items-center" }, [
                  _c(
                    "div",
                    { staticClass: "col-auto" },
                    [
                      _c("ItpFormCheckbox", {
                        staticClass: "form-check form-check-inline",
                        attrs: {
                          name: "include_period",
                          readonly: _vm.readonly,
                          label: _vm._f("pgettext")(
                            "Include period",
                            "ContractServiceItemNameEditor"
                          )
                        },
                        model: {
                          value: item.include_period,
                          callback: function($$v) {
                            _vm.$set(item, "include_period", $$v)
                          },
                          expression: "item.include_period"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("ItpFormSelect", {
                        attrs: {
                          name: "period_format",
                          options: _vm.periodFormats,
                          readonly: _vm.readonly,
                          valueField: "value",
                          textField: "name",
                          "null-option": "",
                          disabled: !item.include_period
                        },
                        model: {
                          value: item.period_format,
                          callback: function($$v) {
                            _vm.$set(item, "period_format", $$v)
                          },
                          expression: "item.period_format"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-auto" },
                    [
                      _c("ItpFormSelect", {
                        attrs: {
                          name: "language",
                          options: _vm.languages,
                          readonly: _vm.readonly,
                          valueField: "value",
                          textField: "name",
                          "null-option": "",
                          disabled: !item.include_period
                        },
                        model: {
                          value: item.language,
                          callback: function($$v) {
                            _vm.$set(item, "language", $$v)
                          },
                          expression: "item.language"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                index != _vm.items.length - 1
                  ? _c("hr", { staticClass: "w-25" })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            !_vm.readonly && !_vm.disabled
              ? _c("div", { staticClass: "col-auto" }, [
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        "data-dismiss": "modal",
                        "aria-label": "Close",
                        title: _vm._f("pgettext")(
                          "Remove name",
                          "ContractServiceItemNameEditor"
                        )
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.evh_4207795475682514_clickPreventStop(
                            $event,
                            { item: item, index: index }
                          )
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ])
              : _vm._e()
          ]
        )
      }),
      _vm._v(" "),
      !_vm.readonly && !_vm.disabled
        ? _c(
            "DIV",
            { staticClass: "d-flex mt-2 align-items-center" },
            [
              _c(
                "DIV",
                {
                  staticClass: "col-auto",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.evh_1040167445267876_clickPreventStop(
                        $event,
                        {}
                      )
                    }
                  }
                },
                [
                  _c("ItpLink", {
                    attrs: {
                      icon: _vm.$config.addIcon,
                      text: _vm._f("pgettext")(
                        "Add name",
                        "ContractServiceItemNameEditor"
                      )
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }